<template>
  <v-container fluid class="down-top-padding">
      <h1>Quicklinks</h1>
      <p>See below links to helpful resources.</p>
      <br>
      <h3>App & Login Support</h3>
      <p>For all questions relating to the MINQ Phone App & Data Dashboard, visit our tech support page.</p>
      <v-btn href="https://moveitnq.com.au/support/" target="_blank" class="info mt-4 text-capitalize" medium color="white">TECH SUPPORT</v-btn><br>
      <br>
      <h3>Program Data Corrections or Updates</h3>
      <p>If a Program is missing or incorrect, please email us and provide specific information about data that needs to be amended.</p>
      <v-btn href="mailto:pc@nqsports.com.au" target="_blank" class="black mt-4 text-capitalize" medium color="white">EMAIL US</v-btn><br>
      <br>
      <h3>Have a success story to share?</h3>
      <p>We are always looking for testimonials and stories to share about participants and instructors involed in Move It NQ</p>
      <v-btn href="https://moveitnq.com.au/story" target="_blank" class="black white--text mt-4 text-capitalize" medium color="Move It NQ Website">SUBMIT A STORY</v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Move It NQ",

  data: () => ({
    elementVisible:false,
    page: {
      title: "Quicklinks"
    },
  }),
  components: {
  }
};
</script>